import { css } from '@emotion/react'

import { mediaQueryUp } from '~/theme/utils/grid'

export const cookieConsentStyle = css`
  #cc-main {
    --cc-btn-primary-bg: #f1a001;
    --cc-btn-primary-hover-bg: #dc7f12;
    --cc-btn-secondary-bg: #eaeaea;
    --cc-btn-secondary-color: #30363c;
    --cc-btn-border-radius: 0.5rem;

    .cm--bar .cm__btns {
      justify-content: center;
      flex-direction: column !important;
      gap: 0.375rem;

      .cm__btn-group {
        flex-direction: column !important;
        gap: 0.75rem;

        ${mediaQueryUp('m')} {
          gap: 0;
        }
      }

      ${mediaQueryUp('m')} {
        flex-direction: row-reverse !important;
        gap: 0;
        > *:first-child {
          flex: 2;
        }
        > *:nth-child(2) {
          flex: 1;
        }
      }
    }

    .cm__btn {
      padding: 0.875rem 2rem;
      font-size: 0.875rem;
      line-height: 0.9625rem;
      font-weight: 500;
      letter-spacing: 0em;
      border: none;
    }
  }
`
